import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=54ed778e&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=54ed778e&prod&scoped=true&lang=css"
import style1 from "./banner.vue?vue&type=style&index=1&id=54ed778e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed778e",
  null
  
)

export default component.exports